
export default {
  name: 'BaseRecommendationsBroadcastsAuthors',
  data() {
    return {
      authors: [],
    }
  },
  async fetch() {
    try {
      this.authors = await this.$axios.$get('authors/broadcasts', {
        params: {
          limit: 10,
        },
      })
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    userName(user) {
      if (user?.type === 'COMPANY') {
        return user?.company?.title ? user?.company?.title : user?.username
      } else {
        return user?.profile?.firstName && user?.profile?.lastName
          ? `${user?.profile.firstName} ${user?.profile.lastName}`
          : user?.username
      }
    },
  },
}
